import { FixedPageHeader } from 'Components/Layout';
import { useSelector } from 'react-redux';

const FixedAgsWorkOrderHeader: React.FC = () => {
  const status = useSelector((state) => state.agsWorkOrderExport.pageHeader?.status);
  const processing = useSelector((state) => state.agsWorkOrderExport.pageHeader?.processing);
  const caption = useSelector((state) => state.agsWorkOrderExport.pageHeader?.shortName);
  const identifier = useSelector((state) => state.agsWorkOrderExport.pageHeader?.identifier);

  return (
    <FixedPageHeader
      pageIdentifier={identifier}
      pageStatus={status}
      pageProcessing={processing}
      pageCaption={caption}
    />
  );
};

export default FixedAgsWorkOrderHeader;
